module.exports = __webpack_public_path__ + "static/media/webhook.bea1825d.md";